<vl-form-grid mod-stacked>
    <template v-if="readOnly">
        <vl-column width="4" width-m="6" width-s="8">
            <aeg-address-details :service="service" />
            <vl-link mod-medium icon='pencil' mod-icon-before mod-block @click="toggleReadOnly">Aanpassen</vl-link>
        </vl-column>
    </template>
    <template v-else>
        <vl-column v-if="showVatNumber" width-l="8" width-m="10" width-s="12">
            <aeg-field-validation-wrapper :error-message="errors.vatNumber" name="BTW-nummer" mod-required #default="{hasErrors}">
                <vl-input-field name="vatNumber" v-model="vatNumber" v-bind="vatNumberProps" :mod-error="hasErrors"
                    mod-block />
            </aeg-field-validation-wrapper>
        </vl-column>
        <vl-column>
            <vl-form-message-label v-if="!isCitizen">Adres van de maatschappelijke zetel:</vl-form-message-label>
            <vl-form-message-label v-else>{{fullName}}</vl-form-message-label>
        </vl-column>
        <vl-column width="4" width-m="6" width-s="8">
            <aeg-field-validation-wrapper :error-message="errors.street" name="Straat" mod-required #default="{hasErrors}">
                <aeg-autocomplete
                    :data="streetData"
                    :fetching="streetDataFetching"
                    name="straat"
                    :modelValue="street"
                    @update:modelValue="onStreetInputChange"
                    @select="onStreetSelect"
                    :mod-error="hasErrors"
                    mod-block />
            </aeg-field-validation-wrapper>
        </vl-column>
        <vl-column width="2" width-m="2">
            <aeg-field-validation-wrapper :error-message="errors.houseNumber" name="Nummer" mod-required #default="{hasErrors}">
                <aeg-autocomplete
                    :data="houseNumberData"
                    :fetching="houseNumberDataFetching"
                    name="nummer"
                    :modelValue="houseNumber"
                    @update:modelValue="onHouseNumberInputChange"
                    @select="onHouseNumberSelect"
                    :mod-error="hasErrors"
                    mod-block
                />
            </aeg-field-validation-wrapper>
        </vl-column>
        <vl-column width="2" width-m="2">
            <aeg-field-validation-wrapper :error-message="errors.boxNumber" name="Bus" #default="{hasErrors}">
                <vl-input-field name="boxNumber" v-model="boxNumber" v-bind="boxNumberProps" :mod-error="hasErrors"
                    mod-block />
            </aeg-field-validation-wrapper>
        </vl-column>
        <vl-column width-l="4" width-m="2" width-s="12" v-vl-visibility:hide.s></vl-column>
        <vl-column width-l="2" width-m="2" width-s="3">
            <aeg-field-validation-wrapper :error-message="errors.postalCode" name="Postcode" mod-required #default="{hasErrors}">
                <vl-input-field name="postalCode" v-model="postalCode" v-bind="postalCodeProps" :mod-error="hasErrors"
                    mod-block />
            </aeg-field-validation-wrapper>
        </vl-column>
        <vl-column width-l="3" width-m="4" width-s="9">
            <aeg-field-validation-wrapper :error-message="errors.city" name="Gemeente" mod-required #default="{hasErrors}">
                <vl-input-field name="city" v-model="city" v-bind="cityProps" :mod-error="hasErrors" mod-block />
            </aeg-field-validation-wrapper>
        </vl-column>
        <vl-column width-l="3" width-m="4" width-s="12">
            <aeg-field-validation-wrapper :error-message="errors.country" name="Land" mod-required #default="{hasErrors}">
                <vl-multiselect name="country" :options="countryOptions.map(c => c.name)" v-model="country"
                    :mod-error="hasErrors" :mod-multiple="false" placeholder="Kies een land" mod-block />
            </aeg-field-validation-wrapper>
        </vl-column>
        <vl-column v-if="emails.length > 1">
            <vl-title tag-name="span" tag-style="h4">E-mails facturatie</vl-title>
            <div>
            <span>Vul hier e-mailadressen in waarop uw organisatie vragen omtrent facturatie wenst te ontvangen per service.<br>
                U ontvangt de factuur via Peppol indien u daarop bent aangesloten.
            </span>
            </div>
        </vl-column>        
        <vl-column width-l="8" width-m="10" width-s="12" v-if="showEmail" v-for="(field, index) in emails" :key="field.key">
            <aeg-field-validation-wrapper :error-message="errors[`emails[${index}].email`]" :name="`E-mail facturatie ${field.value.service}`" mod-required #default="{hasErrors}"
                :annotation="!isCitizen && emails.length === 1 ? annotation : ''">
                <vl-input-field name="email" v-model="field.value.email" :mod-error="hasErrors" mod-block />
            </aeg-field-validation-wrapper>
        </vl-column>
    </template>
</vl-form-grid>